import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './reducers'
import thunk from 'redux-thunk'
import logger from './middleware/logger'
import api from './middleware/api'
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key:'root',
    storage
}

const persistedReducer = persistReducer(persistConfig,rootReducer);

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, 
                                    composeWithDevTools(
                                        applyMiddleware(
                                            thunk,
                                            logger,
                                            api
                                            )))

const Persistor = persistStore(store);

export {Persistor};
export default store
